import { useAuth } from 'common/context/AuthContext';
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';



export const PrivateRoutesToken: React.FC = () => {
  const { token } = useAuth();
  let realToken = token;
  if (!token) {
    const cookies = new Cookies();
    realToken = cookies.get('token');
  }

  const location = useLocation();
  return (
    realToken ? <Outlet /> : <Navigate to="/login" replace={true} state={{ from:location.pathname }}/>
  );
};

export const PrivateRoutesCompanyId: React.FC = () => {
  const { companyId } = useAuth();
  let realCompanyId = companyId;
  if (!companyId) {
    const cookies = new Cookies();
    realCompanyId = cookies.get('companyId');
  }

  const location = useLocation();
  return (
    realCompanyId ? <Outlet /> : <Navigate to="/registration" replace={true} state={{ from:location.pathname }}/>
  );
};